module.exports = __webpack_public_path__ + "static/logo-669fdf91a270e31e37d61bafa393e527.svg";